import { Grid } from '@mui/material'
import { InfoBox, InfoBoxProps, SectionHeader, WrapperProps } from '..'

export interface LayoutWithTitleAndInfoProps extends WrapperProps {
  addTopPadding?: boolean
  infoBoxProps?: InfoBoxProps
  titleTranslationBottomId?: string
  titleTranslationBottomText?: string
  titleTranslationTopId?: string
  titleTranslationTopText?: string
}

export const LayoutWithTitleAndInfo = ({
  addTopPadding = true,
  children,
  infoBoxProps,
  titleTranslationBottomId,
  titleTranslationBottomText,
  titleTranslationTopId,
  titleTranslationTopText
}: LayoutWithTitleAndInfoProps) => {
  const hasTopTitle =
    titleTranslationTopId !== undefined || titleTranslationTopText !== undefined
  const hasBottomTitle =
    titleTranslationBottomId !== undefined ||
    titleTranslationBottomText !== undefined

  return (
    <Grid container>
      {hasTopTitle && (
        <Grid
          item
          md={12}
          xs={12}
          pb={infoBoxProps ? 1 : 0}
          pt={addTopPadding ? 3 : 0}
        >
          <SectionHeader
            primaryText={titleTranslationTopText}
            primaryTextId={titleTranslationTopId}
          />
        </Grid>
      )}
      {infoBoxProps && (
        <Grid item md={12} xs={12} pb={hasBottomTitle ? 2 : 0}>
          <InfoBox {...infoBoxProps} />
        </Grid>
      )}
      {hasBottomTitle && (
        <Grid item md={12} xs={12}>
          <SectionHeader
            primaryText={titleTranslationBottomText}
            primaryTextId={titleTranslationBottomId}
          />
        </Grid>
      )}
      <Grid item md={12} xs={12}>
        {children}
      </Grid>
    </Grid>
  )
}
